/* eslint-disable no-unused-vars */
/* eslint-disable react/prop-types */
import React, { useState } from "react";
// import throttle from "lodash/throttle";
import { WithLazy } from "@quintype/components";

import { AdContainer } from "../../ads";
import SideBarContent from "../../molecules/sidebar-content";
import LatestNews from "../story-elements/latest-news";
import TaboolaAd from "../../ads/taboola-ad";

import "./story-sidebar.m.css";
import useAdType from "../../helper/custom-hook/useAdType";

const StorySideBar = ({ story }) => {
  const [renderTaboolaAd, setRenderTaboolaAd] = useState(true);
  const adType = useAdType();

  // useEffect(() => {
  //   const getScroll = () => {
  //     if (typeof window !== "undefined") {
  //       if (window.scrollY > 500) setRenderTaboolaAd(true);
  //     }
  //   };
  //   window.addEventListener("scroll", throttle(getScroll, 300));
  //   return () => window.removeEventListener("scroll", getScroll);
  // }, []);

  return (
    <div styleName="wrapper">
      <div styleName="ad" className="hide-mobile">
        <AdContainer
          AdClassName="standard-300x250"
          id={adType === "izooto" ? "div-gpt-ad-1711630701693-0" : "div-gpt-ad-1675837126868-0"}
          desktop={adType === "izooto" ? "PV_Desktop_AP_RT_ym" : "PV_Desktop_AP_RT"}
          isExternalAdPath={adType === "izooto"}
        />
      </div>
      <div styleName="sidebar-slider-wrapper">
        <SideBarContent title="ಪ್ರಜಾವಾಣಿ ವಿಡಿಯೊ" speed={2500} type={"video"} />
      </div>
      <WithLazy margin="300px">{() => <LatestNews story={story} />}</WithLazy>
      {story["story-template"] === "photo" ? (
        <SideBarContent title="ಟ್ರೆಂಡಿಂಗ್ ಫೊಟೋಗಳು" speed={2500} type={"photo"} />
      ) : null}
      <div styleName="sidebar-slider-wrapper">
        <SideBarContent title="ಸಿನಿಮಾ" speed={3000} type={"cinema"} />
      </div>
      <div styleName="ad" className="hide-mobile">
        <AdContainer
          AdClassName="standard-300x250"
          id={adType === "izooto" ? "div-gpt-ad-1711630889490-0" : "div-gpt-ad-1675837205470-0"}
          desktop={adType === "izooto" ? "PV_Desktop_AP_RM_ym" : "PV_Desktop_AP_RM"}
          isExternalAdPath={adType === "izooto"}
        />
      </div>
      {renderTaboolaAd ? (
        <div className="hide-mobile">
          <TaboolaAd container="taboola-right-rail-thumbnails" placement="Right Rail Thumbnails" mode="thumbnails-rr" />
        </div>
      ) : null}
    </div>
  );
};

export default StorySideBar;
